/* esm.sh - lit-html@3.3.3/directives/choose */
var n=(r,t,e)=>{for(let o of t)if(o[0]===r)return(0,o[1])();return e?.()};export{n as choose};
/*! Bundled license information:

lit-html/directives/choose.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
//# sourceMappingURL=choose.mjs.map